<template>
    <span :data-balloon="tooltip" data-balloon-pos="up">
        <button class="delete simple" @click="open"><i class="fa fa-trash"></i></button>
        <div class="remodal" :data-remodal-id="modalID">
            <p>Are you sure you want to delete <strong>{{title}}</strong>?</p>
            <button data-remodal-action="cancel" class="remodal-cancel simple">Cancel</button>
            <button data-remodal-action="confirm" class="remodal-confirm simple" @click="confirm">OK</button>
        </div>
    </span>

</template>

<script>
    import Modal from 'vue/common/_modal';
    import {mapActions} from 'vuex'

    export default {
        computed: {
            modalID() {
                return `${this.id}-delete`
            },
            item() {
                return {
                    id: this.id,
                    url: this.url
                }
            }
        },

        methods: {
            confirm() {
                if (this.seismic) {
                    let route = 'seismicDesign/destroy';
                    if (this.url.indexOf('seismicSubmittal') != -1) {
                        route = 'submittalDesign/destroy';
                    }

                    this.$store.dispatch(route, {id: this.id})
                    .then(() => {
                        //Temporary before we change this template into a vue template
                        if (window.location.pathname.startsWith('/submittal-manager')) {
                            window.location.reload();
                        }
                    });
                } else {
                    this.deleteItem(this.item)
                    .then(() => {
                        //Temporary before we change this template into a vue template
                        if (window.location.pathname.startsWith('/submittal-manager')) {
                            window.location.reload();
                        }
                    });
                }
            },
            ...mapActions('mechanical', [
                'deleteItem'
            ])
        },
        extends: Modal,

        props: {
            id: {
                type: String
            },
            seismic: {
                type: Boolean
            },
            title: {
                type: String
            },
            url: {
                type: String
            },
            tooltip: {
                default: "Delete Project",
                type: String
            },
        },
    }
</script>
